import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

const selectDiscoveryQuizState = (state: AppStateType) => state?.discoveryQuiz;

const selectCurrentDiscoveryQuizProductInstance = createSelector(
  [selectDiscoveryQuizState],
  state => state?.currentDiscoveryQuizProductInstance,
);

const selectDiscoveryQuizProductInstances = createSelector(
  [selectDiscoveryQuizState],
  state => state?.discoveryQuizProductInstances,
);

const selectIsDiscoveryQuizProductInstancesLoading = createSelector(
  [selectDiscoveryQuizState],
  state => state?.isDiscoveryQuizProductInstancesLoading,
);

export {
  selectCurrentDiscoveryQuizProductInstance,
  selectDiscoveryQuizProductInstances,
  selectIsDiscoveryQuizProductInstancesLoading,
};
